import { IEventsInstance } from './IEventsInstance.ts';
import { Singleton } from './Singleton.ts';

/**
 * Пустая реализация класса для отправки событий
 * Не отправляет никаких событий, используется для тестирования или отключения аналитики
 */
export class EmptyEventsInstance extends Singleton implements IEventsInstance {
    public sessionId: number | undefined;
    public deviceId: string | undefined;
    public canSendEvent: boolean = false;

    constructor() {
        super();
    }

    /**
     * Пустая реализация метода инициализации
     */
    public run(): void {
        // Ничего не делаем
    }

    /**
     * Пустая реализация метода отправки события
     */
    public sendEvent(_eventGroup: string, _eventName: string, _eventValue: any): void {
        // Ничего не делаем
    }
}
